import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

import { Link } from 'core/routing';

export const SideNavBarWrapper = styled.div`
  width: calc(25% - 10px);
  float: left;
  margin-bottom: ${props => props.theme.spacing.default};
  position: sticky;
  top: 95px;
  overflow: hidden;
  ${media.l`
    width: calc(27% - 10px);
  `};
  ${media.m`
    width: 100%;
    position: relative;
    top: 0;
    margin-bottom: 0;
  `};
`;

export const SideNavBar = styled.ul`
  overflow: hidden;
  margin-top: ${props => props.theme.spacing.large};
`;

export const SideNavBarItem = styled.li`
  font-size: ${props => (props.isTitle ? '1.25rem' : '0.925em')};
  font-weight: ${props =>
    props.isTitle
      ? props.theme.font.weight.xbold
      : props.theme.font.weight.regular};
  color: ${props => props.theme.color.wfBlack};
  padding: ${props =>
    props.isTitle ? '0px 10px 20px 0px' : '0px 10px 8px 0px'};
  line-height: 1.55;
  > a {
    color: ${props => props.theme.color.primary};
    font-weight: 600;
  }
`;

export const SideNavBarLink = styled(Link)`
  font-weight: ${props => props.theme.font.weight.regular} !important;
  color: ${props => props.theme.color.wfBlack} !important;
  border-left: ${props =>
    props.active ? `3px solid ${props.theme.color.primary}` : 'none'};
  padding: 8px 10px;
  display: block;
  &:hover {
    text-decoration: none !important;
    color: ${props => props.theme.color.primary} !important;
  }
`;
